


































import { numberInputValid } from '@/common/Validators';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AddFeedTankModal extends Vue {
	@Prop({ required: true, type: Function })
	private createFeedTank!: (params: { nominalVolume: number; name: string }) => Promise<void>;

	@Prop({ required: true, type: Function })
	private onTankCreated!: () => Promise<void>;

	public name: string = '';
	public nominalVolume: number = 0;

	public get nominalVolumeValid(): boolean {
		return numberInputValid({
			field: this.nominalVolume,
			min: 0,
			max: null,
		});
	}

	public get nameValid(): boolean {
		return this.name.length > 0;
	}

	public get canSubmit(): boolean {
		return this.nominalVolumeValid && this.nameValid;
	}

	public async onSave(): Promise<void> {
		await this.createFeedTank({
			nominalVolume: this.nominalVolume,
			name: this.name,
		});
		await this.onTankCreated();
	}
}
